

export async function generateSignedUrl(url) {
	const encoder = new TextEncoder();
	const secretKeyData = encoder.encode("2qySfsbI5akSqHmj_empreinte_bNLt1pnS4I");
	const key = await crypto.subtle.importKey(
		"raw",
		secretKeyData,
		{ name: "HMAC", hash: "SHA-256" },
		false,
		["sign"]
	);

	const expiry = Date.now() + 3 * 60 * 1000; // 3min
	let dataToAuthenticate = `${url.pathname}@${expiry}`;


	const mac = await crypto.subtle.sign("HMAC", key, encoder.encode(dataToAuthenticate));
	let base64Mac = btoa(String.fromCharCode(...new Uint8Array(mac)))
	url.searchParams.set("mac", base64Mac);
	url.searchParams.set("expiry", expiry.toString());

	return url.toString();
  }
